<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-card>
      <v-card-title>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Vessel Details
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
      <v-flex xs12>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.paramName }}</td>
                <td class="text-xs-left">{{ row.item.paramType }}</td>
                <td class="text-xs-left">{{ row.item.paramDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item.paramName)"
                    query
                    @query="doQuery(row.item.paramName)"
                    remove
                    @remove="doPromptRemove(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove">
      <div class="queryValue">[{{ selected.paramName }}]</div>
      Are you sure you want to delete the selected Vessel Details?
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { marineDataMixin } from '@/mixins/params/marineDataMixin'

export default {
  data() {
    return {
      marineParam: 'vslDet',
      headers: [
        { text: 'Vessel No.', value: 'paramName' },
        { text: 'Vessel Name', value: 'paramType' },
        { text: 'Description', value: 'paramDesc' },
        TableConst.tableActionHeader
      ],
      selected: {
        paramName: null,
        paramDesc: null,
        paramType: null
      },
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    init() {
      this.doInit(this.marineParam)
    },
    doNew() {
      this.$router.push({ name: 'vslDetReview', params: { vesselDetMode: 'create' } })
    },
    doQuery(paramName) {
      this.$router.push({ name: 'vslDetReview', params: { vesselDetMode: 'query', paramName: paramName, vsl: paramName } })
    },
    doReview(paramName) {
      this.$router.push({ name: 'vslDetReview', params: { vesselDetMode: 'review', paramName: paramName, vsl: paramName } })
    },
    doPromptRemove(item) {
      if (item) {
        this.selected.paramName = item.paramName
        this.selected.paramType = item.paramType
        this.selected.paramDesc = item.paramDesc
        this.promptRemove = true
      }
    },
    async doRemove() {
      this.resetMessages()
      if (this.selected && this.selected.paramName) {
        const apiURI = this.$store.state.marineParam.menu.deleteVsl
        if (apiURI) {
          const expand = {
            actionKey: 'vslDet',
            paramName: this.selected.paramName,
            paramType: this.selected.paramType,
            paramDesc: this.selected.paramDesc
          }
          this.$http
            .post(apiURI, expand)
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.init()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  created() {
    this.init()
  },
  mixins: [TableConst.default, marineDataMixin]
}
</script>
